export default __webpack_public_path__ + "static/media/bg-large-orange.fa817a52.svg";